import cx from 'classnames'
import { FC, useMemo } from 'react'
import { ActionButtonProps } from 'src/components/ActionButton'
import { BlockTitleProps } from 'src/components/BlockTitle'
import { IllustrationProps } from 'src/components/Illustration'
import { RichTextProps } from 'src/components/RichText'
import { motionSlide } from 'src/hooks/useAppear'

import * as SC from './styled'

export type IllustrationGridProps = {
  className?: string
  blockTitleProps?: BlockTitleProps
  illustrations?: IllustrationProps[]
  richTextProps?: RichTextProps
  actionButtonProps?: ActionButtonProps
}

const IllustrationGrid: FC<IllustrationGridProps> = ({
  className,
  blockTitleProps,
  illustrations,
  richTextProps,
  actionButtonProps,
}) => {
  const { motions } = useIllustrationGridMotion()

  return illustrations && illustrations.length > 0 ? (
    <SC.Container className={cx('IllustrationGrid', className)}>
      {blockTitleProps && <SC._BlockTitle {...blockTitleProps} />}
      <SC.Wrapper>
        <SC.Grid>
          {illustrations.map((picture, index) => (
            <SC._Illustration
              key={`illustration-motion-${index}`}
              {...picture}
              {...(index % 2
                ? motions.illustrationDelayed
                : motions.illustration)}
            />
          ))}
        </SC.Grid>
        {(richTextProps || actionButtonProps) && (
          <SC.Content>
            {richTextProps && <SC._RichText {...richTextProps} />}
            {actionButtonProps && <SC._ActionButton {...actionButtonProps} />}
          </SC.Content>
        )}
      </SC.Wrapper>
    </SC.Container>
  ) : null
}

const useIllustrationGridMotion = () => {
  const motions = useMemo(
    () => ({
      illustration: motionSlide({}).motionProps,
      illustrationDelayed: motionSlide({ delay: 0.12 }).motionProps,
    }),
    []
  )

  return { motions }
}

export default IllustrationGrid
